export default ($t) => ({
  title: "AddTeamFromCampaign",
  type: "object",
  noValidateChild: false,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    // hide_parent_team_field: {
    //   title: "Hide parent team field",
    //   type: "boolean",
    //   default: false
    // },
    use_phone_as_shortlink: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_use_phone_as_shortlink",
        "Use phone as shortlink"
      ),
      type: "boolean",
      expanded: true,
      default: false,
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_use_phone_as_shortlink_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    use_leadername_as_shortlink: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_use_leadername_as_shortlink",
        "Use leader name as shortlink"
      ),
      type: "boolean",
      expanded: true,
      default: false,
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_use_leadername_as_shortlink_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    not_autogenerate_shortlink: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_not_autogenerate_shortlink",
        "Not autogenerate shortlink"
      ),
      type: "boolean",
      expanded: true,
      default: false,
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_not_autogenerate_shortlink_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    hide_btn: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_hide_btn",
        "Hides the team form button"
      ),
      type: "boolean",
      expanded: true,
      default: false,
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_hide_btn_description",
        "Hides the team form button when add_team_from_campaign is enabled"
      ),
    },
    hidden: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_hidden",
        "New team cards should appear on the screen"
      ),
      type: "boolean",
      expanded: true,
      default: false,
      description: $t("edit_campaign.schema_add_team_from_campaign_hide_btn_description", {
        returnEmptyOnMissing: true,
      }),
    },
    // send_sms: {
    //   title: "Send sms",
    //   type: "boolean",
    //   default: true
    // },
    // parent_team_list: {
    //   title: "Parent team list",
    //   type: "enum",
    //   default: [],
    //   items: {
    //     title: "Items",
    //     type: "enum",
    //     default: "",
    //     enum: [
    //       {
    //         text: "All teams",
    //         value: ""
    //       },
    //       {
    //         text: "Parent only",
    //         value: "parent_only"
    //       },
    //       {
    //         text: "Grandparent only",
    //         value: "grandparent_only"
    //       }
    //     ]
    //   }
    // },
    // theme: {
    //   title: "Theme",
    //   type: "string",
    //   default: "",
    //   pattern: "^.*$"
    // },
    // "image": {
    //   "title": "Image",
    //   "type": "object",
    //   "properties": {
    //     "src": {
    //       "title": "Src",
    //       "type": "string",
    //       "default": "",
    //       "pattern": "^.*$"
    //     },
    //     "disable_change": {
    //       "title": "Disable change",
    //       "type": "boolean",
    //       "default": true
    //     },
    //     "hide": {
    //       "title": "Hide",
    //       "type": "boolean",
    //       "default": true
    //     }
    //   }
    // },
    form: {
      title: $t("edit_campaign.schema_add_team_from_campaign_form", "Form"),
      type: "object",
      properties: {
        leader_name: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_leader_name", "Leader name"),
          type: "object",
          properties: {
            hide: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_leader_name_hide",
                "Hide"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_leader_name_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_leader_name_required",
                "Required"
              ),
              type: "boolean",
              default: true,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_leader_name_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        name: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_name", "Team name"),
          type: "object",
          properties: {
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_name_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_name_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        phone: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_phone", "Phone"),
          type: "object",
          properties: {
            hide: {
              title: $t("edit_campaign.schema_add_team_from_campaign_form_phone_hide", "Hide"),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_phone_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_phone_required",
                "Required"
              ),
              type: "boolean",
              default: true,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_phone_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_phone_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_phone_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        email: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_email", "Email"),
          type: "object",
          properties: {
            hide: {
              title: $t("edit_campaign.schema_add_team_from_campaign_form_email_hide", "Hide"),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_email_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_email_required",
                "Required"
              ),
              type: "boolean",
              default: true,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_email_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        parent_team: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_parent_team", "Parent team"),
          type: "object",
          properties: {
            hide: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_hide",
                "Hide"
              ),
              type: "boolean",
              default: true,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_required",
                "Required"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_parent_team_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        description: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_description", "Description"),
          type: "object",
          properties: {
            hide: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_hide",
                "Hide"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_required",
                "Required"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_description_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        goal: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_goal", "Goal"),
          type: "object",
          properties: {
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            allow_arbitrary_currency: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_allow_arbitrary_currency",
                "Allow arbitrary currency"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_allow_arbitrary_currency_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            min: {
              title: $t("edit_campaign.schema_add_team_from_campaign_form_goal_min", "Min Goal"),
              type: "number",
              default: 0,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_min_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            max: {
              title: $t("edit_campaign.schema_add_team_from_campaign_form_goal_max", "Max Goal"),
              type: "number",
              default: 100000,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_goal_max_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
        donor_goal: {
          title: $t("edit_campaign.schema_add_team_from_campaign_form_donor_goal", "Donor goal"),
          type: "object",
          properties: {
            allow_edit: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_donor_goal_allow_edit",
                "Allow Edit"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_donor_goal_allow_edit_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            hide: {
              title: $t("edit_campaign.schema_add_team_from_campaign_form_donor_goal_hide", "Hide"),
              type: "boolean",
              default: true,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_donor_goal_hide_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
            required: {
              title: $t(
                "edit_campaign.schema_add_team_from_campaign_form_donor_goal_required",
                "Required"
              ),
              type: "boolean",
              default: false,
              description: $t(
                "edit_campaign.schema_add_team_from_campaign_form_donor_goal_required_description",
                {
                  returnEmptyOnMissing: true,
                }
              ),
            },
          },
        },
      },
    },
    colors: {
      title: $t("edit_campaign.schema_add_team_from_campaign_colors", "Form colors"),
      type: "object",
      properties: {
        value: {
          title: $t("edit_campaign.schema_add_team_from_campaign_colors_value", "Active"),
          type: "boolean",
          default: false,
          description: $t("edit_campaign.schema_add_team_from_campaign_colors_value_description", {
            returnEmptyOnMissing: true,
          }),
        },
        background: {
          title: $t("edit_campaign.schema_add_team_from_campaign_colors_background", "Background"),
          type: "color",
          default: "#ffffff",
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_colors_background_description",
            {
              returnEmptyOnMissing: true,
            }
          ),
        },
        background_secondary: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_colors_background_secondary",
            "Background secondary"
          ),
          type: "color",
          default: "#fbfcff",
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_colors_background_secondary_description",
            {
              returnEmptyOnMissing: true,
            }
          ),
        },
        text: {
          title: $t("edit_campaign.schema_add_team_from_campaign_colors_text", "Text"),
          type: "color",
          default: "#212529",
          description: $t("edit_campaign.schema_add_team_from_campaign_colors_text_description", {
            returnEmptyOnMissing: true,
          }),
        },
        text_secondary: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_colors_text_secondary",
            "Text secondary"
          ),
          type: "color",
          default: "#20434e",
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_colors_text_secondary_description",
            {
              returnEmptyOnMissing: true,
            }
          ),
        },
      },
    },
    banner: {
      title: $t("edit_campaign.schema_add_team_from_campaign_banner", "Banner"),
      type: "object",
      expanded: true,
      properties: {
        value: {
          title: $t("edit_campaign.schema_add_team_from_campaign_banner_value", "Active"),
          type: "boolean",
          default: false,
          description: $t("edit_campaign.schema_add_team_from_campaign_banner_value_description", {
            returnEmptyOnMissing: true,
          }),
        },
        options: {
          title: $t("edit_campaign.schema_add_team_from_campaign_banner_options", "Images"),
          type: "list",
          default: [],
          items: {
            type: "object",
            properties: {
              src: {
                title: $t("edit_campaign.schema_add_team_from_campaign_banner_options_src", "Src"),
                type: "image",
                default: "",
                description: $t(
                  "edit_campaign.schema_add_team_from_campaign_banner_value_description",
                  {
                    returnEmptyOnMissing: true,
                  }
                ),
              },
            },
          },
        },
      },
    },
    goal_categories: {
      title: $t("edit_campaign.schema_add_team_from_campaign_goal_categories", "Goal categories"),
      type: "object",
      component: "GoalCategoriesSection",
      expanded: true,
      properties: {
        value: {
          title: "Active",
          type: "boolean",
          default: false,
        },
        view: {
          title: "View Mode",
          type: "enum",
          default: "card-list",
          items: {
            enum: [
              {
                text: "Card list",
                value: "card-list",
              },
              {
                text: "Dropdown list",
                value: "standard",
              },
            ],
          },
        },
        options: {
          title: "Items",
          type: "list",
          default: [],
          items: {
            type: "object",
            properties: {
              price: {
                title: "Price",
                type: "number",
                default: 0,
              },
              title: {
                title: "Title",
                type: "string",
                default: "",
              },
              subtitle: {
                title: "Subtitle",
                type: "string",
                default: "",
              },
              image: {
                title: "Image",
                type: "string",
                default: "",
              },
              level_ids: {
                title: "Levels",
                type: "array",
                default: [],
                items: {
                  title: "Items",
                  type: "number",
                  default: 0,
                },
              },
            },
          },
        },
      },
    },
    collect_credit_card_mandatory: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_collect_credit_card_mandatory",
        "Collect Credit Card"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_collect_credit_card_mandatory_description",
        "User created teams will be required to enter credit card information before team can be activated."
      ),
    },
    collect_credit_card_and_charge_immediately: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately",
        "Enable a team creation fee and apply the charge when a team is created"
      ),
      type: "object",
      expanded: true,
      form: true,
      properties: {
        value: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_value",
            "Active"
          ),
          type: "boolean",
          default: false,
        },
        currency: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_currency",
            "Currency"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_currency_description",
            "Specifies the currency for the registration fee."
          ),
          type: "string",
          component: "CurrenciesSelect",
        },
        amount: {
          $if(form) {
            return form?.value || false;
          },
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_amount",
            "Amount"
          ),
          type: "number",
          default: 1,
          min: 1,
          required: true,
          pattern: "^[1-9][0-9]*$",
          validationMessage: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_amount_validation_message",
            "Amount must be a positive integer greater than 0"
          ),
          formatter: {
            handler: (value) => {
              if (value === 0) {
                return 1;
              }

              return Math.abs(value);
            },
          },
        },
        amount_text: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_amount_text",
            "Amount text"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_amount_text_description",
            "Text to display for user when entering credit card information."
          ),
          type: "string",
        },
        add_optional_donation_amount: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_add_optional_donation_amount",
            "Add optional donation amount"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_add_optional_donation_amount_description",
            "Enables an additional optional donation field during team registration. When true, the optional donation field is shown; when false, it remains hidden."
          ),
          type: "boolean",
        },
        optional_donation_amount_text: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_optional_donation_amount_text",
            "Optional donation amount text"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_optional_donation_amount_text_description",
            "Text to display for the optional donation amount field."
          ),
          type: "string",
        },
        team_registration_fee_not_to_team: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_team_registration_fee_not_to_team",
            "Team registration fee not to team"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_team_registration_fee_not_to_team_description",
            "Determines if the registration fee should be allocated to the organization instead of the team. When true, the registration fee goes to the organization; when false, it goes to the team."
          ),
          type: "boolean",
        },
        optional_donation_amount_not_to_team: {
          title: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_optional_donation_amount_not_to_team",
            "Optional donation amount not to team"
          ),
          description: $t(
            "edit_campaign.schema_add_team_from_campaign_collect_credit_card_and_charge_immediately_optional_donation_amount_not_to_team_description",
            "Determines if the optional donation amount should be allocated to the organization instead of the team. When true, the optional donation goes to the organization; when false, it goes to the team. This setting only has effect when AddOptionalDonationAmount is true."
          ),
          type: "boolean",
        },
      },
    },
    show_on_sticky_footer: {
      title: $t(
        "edit_campaign.schema_add_team_from_campaign_show_on_sticky_footer",
        "Show the create team button in the sticky footer"
      ),
      description: $t(
        "edit_campaign.schema_add_team_from_campaign_show_on_sticky_footer_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
      expanded: true,
      type: "boolean",
    },
  },
});
